/**
 * @fileoverview Authentication configuration for the application.
 */

import type { Authentication } from '@/app/providers/AppProvider';
import { signOut } from './session/auth';

export const AUTHENTICATION: Authentication = {
  signIn: () => { window.location.href = '/api/auth/github'; },
  signOut,
};
